export const TOTAL_RATING_NUMBER = 5;
export const TURN_TO_DEFAULT_LOAD_LIMIT = 5;
export const MAX_MEDIA_FILES_NUMBER = 5;

export const filtersMap = {
    '1': '1 star',
    '2': '2 stars',
    '3': '3 stars',
    '4': '4 stars',
    '5': '5 stars',
};

export const PHOTO_FILES_LIMIT_SIZE = 10000000;
